import { useSelector } from 'react-redux';

import CheckoutSummary from 'organisms/CheckoutSummary';
import { prettifyDate } from 'util';

export default function Summary() {
  const {
    appointment,
    summary,
    isSummaryLoading: isLoading,
    service,
  } = useSelector((state) => state.checkout);
  return (
    <div className="mb-12 p-24 border-light-purple radius-24 flex-column">
      <h4 className="mb-8">Service summary</h4>
      {!!appointment?.dateStart && (
        <p className="flex-row mb-15 f13">
          {prettifyDate(appointment?.dateStart)}
        </p>
      )}
      {service?.name ? (
        <CheckoutSummary summary={summary} isLoading={isLoading} />
      ) : (
        <p className="f13">No service selected</p>
      )}
    </div>
  );
}
